module.exports = __webpack_public_path__ + "img/268.coffee_accessories.693fda51.svg";